/**
 * Centralized frontend configuration
 * 
 * Priority: runtime config (fetched from API) > build-time env vars
 * 
 * Usage:
 *   import config from 'config';
 *   const url = config.API_URL;
 */

let runtimeConfig = null;

const config = {
  get API_URL() {
    // Always return empty string → relative URLs (/api/...) work in ALL environments
    // (preview, production, dev). The ingress/proxy routes /api/* to the backend.
    return '';
  },
  get GOOGLE_MAPS_API_KEY() {
    return runtimeConfig?.GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
  },
  get UPLOADCARE_PUBLIC_KEY() {
    return runtimeConfig?.UPLOADCARE_PUBLIC_KEY || process.env.REACT_APP_UPLOADCARE_PUBLIC_KEY || '';
  },
  get STRIPE_PUBLISHABLE_KEY() {
    return runtimeConfig?.STRIPE_PUBLISHABLE_KEY || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
  },
};

/**
 * Initialize runtime config from the backend.
 * Called once before React mounts.
 * Uses relative URL so it works in any environment (preview, production).
 */
export async function initConfig() {
  try {
    const res = await fetch('/api/config/public', { cache: 'no-store' });
    if (res.ok) {
      runtimeConfig = await res.json();
    }
  } catch {
    // Fallback to build-time env vars — silent failure is OK
  }
}

export default config;
